import { useEffect, useRef } from "react";
export default function AutoLogout({ logout, timeoutMs = 30 * 60 * 1000 }) {
  const timerRef = useRef(null);

  const resetTimer = () => {
    try { localStorage.setItem("lastActivityAt", String(Date.now())); } catch {}
    startTimer();
  };

  const startTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      logout();
    }, timeoutMs);
  };

  useEffect(() => {
    startTimer();

    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "click"];
    events.forEach(ev => window.addEventListener(ev, resetTimer, { passive: true }));

    const onVisibility = () => {
      if (document.visibilityState === "visible") resetTimer();
    };
    document.addEventListener("visibilitychange", onVisibility);

    const onStorage = (e) => {
      if (e.key === "lastActivityAt") startTimer();
    };
    window.addEventListener("storage", onStorage);

    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(ev => window.removeEventListener(ev, resetTimer));
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return null;
}
